export default __webpack_public_path__ + "static/CommonAcademy logo-8d7f15bcbfd99522a08403d393144171.png";